// extracted by mini-css-extract-plugin
export var wordContainer = "_s0-0";